import { Col, Row, Title } from 'ui';
import { ChangePasswordForm } from './change-password-form';

const ChangePassword = () => (
  <Row gutter={[0, 'ms']}>
    <Col span={24}>
      <Title level={3}>Change password</Title>
    </Col>
    <Col span={24}>
      <ChangePasswordForm />
    </Col>
  </Row>
);

export default ChangePassword;
